<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-06-09 09:49:10
 * @LastEditTime: 2020-09-10 17:08:49
 * @Description: 
-->
<template>
  <div>
    <Row class="section-first">
      <Col offset="4" span="10">
        <h1>科隆云</h1>
        <h2>科隆智谷一体化管理平台</h2>
        <h3>
          一个集齐工业自动化、客户管理、配方管理的一站式化工行业的专业管理系统
        </h3>

        <Button size="large" type="primary" to="/signup">免费注册</Button>

        <Button size="large" style="margin-left: 20px" to="/login">登录</Button>
      </Col>
    </Row>
    <div class="footer">
      <span>© 2024 深圳市智达万物物联网有限公司</span>
      <a class="icptext" target="blank" href="http://beian.miit.gov.cn"
        >&emsp;|&emsp;粤ICP备19057831号</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "landing",
  components: {},
  computed: {},
  mounted() {
    const token = localStorage.getItem("token");
    if (token) this.$router.push("/home/instrumentPanel");
  },
};
</script>

<style scoped lang="stylus">
.section-first
  height 700px
  width 100%
  background url('../../assets/index_bg.png')
  background-repeat no-repeat
  background-position right top
  // background-size: contain;
  background-size auto 100%

  h1
    margin 200px 0 0px 0
    font-size 5em

  h2
    font-size 3em
    font-weight 300

  h3
    margin 10px 0 40px
    font-weight 300
    font-size 24px

.footer
  width 100%
  height 32px
  text-align center
  color darkgray

.icptext
  color darkgray
  text-decoration none
</style>
